import axios from 'axios';
import "../App.css"
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import Papa from "papaparse";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import UnauthorizedAccess from './UnauthorizedAccess'

function UploadFSTeachers({ IP, TOKEN }) {

    const { register, handleSubmit, formState: { errors } } = useForm()
    const [duplicates, setDuplicates] = useState([])
    const [showDuplicates, setShowDuplicates] = useState(false)
    const [reports, setReports] = useState([])
    const [fileData, setFileData] = useState({})
    const [show, setShow] = useState(false);
    // var [formData, setFormData] = useState([])
    const [uploading, setUploading] = useState(false)
    const [uploaded, setuploaded] = useState(false);
    const [fsBatches, setFsBatches] = useState([])
    const [unAuth, setUnauth] = useState(false)

    const UploadMentorsData = (formData) => {
        setUploading(true)
        // formData = { ...formData, "fileDataAsObject": fileDataAsObject }
        let requestData = { formData, TOKEN }
        axios.post(`http://${IP}/add-fs-teacher`, requestData)
            .then((res) => {

                if (res.data.msg === "Unauthorized access") {
                    setUnauth(true)
                }
                else {
                    if (res.data.msg == "Data added successfully") {
                        notifySuccess(res.data.msg);
                    }
                    if (res.data.msg == "Username already exists") {
                        notifyError(res.data.msg);
                    }
                }
            })
            .catch(err => console.log(err))
        setShow(false)
    }

    useEffect(() => {
        fetchFsBatchNames()
    }, [])

    const fetchFsBatchNames = async () => {
        await axios.get(`http://${IP}/fs-all-batch-names/${TOKEN}`)
            .then(res => {
                setFsBatches(res.data.FSBatches)
            })
            .catch(err => console.log(err))

    }

    const notifySuccess = (msg) => {
        toast.success(msg, {
            toastId: 1,
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            width: "fit-content"
        });
    }

    const notifyError = (msg) =>
        toast.error(msg, {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });

    const handleClose = () => {
        setShow(false);
        setuploaded(false)
    }

    const showdup = () => {
        setShowDuplicates(!showDuplicates)
    }

    return (
        <div>
            {
                unAuth === true ?
                    <div>
                        <UnauthorizedAccess />
                    </div>
                    :
                    <div className='container mt-5 row col-lg-4 col-md-6 col-sm-8 col-xs-12 m-auto'>
                        <form className='upload-form mb-4 mt-2' onSubmit={handleSubmit(UploadMentorsData)}>
                            <h5 className='text-start mb-1 mt-2'>Add FS Teacher</h5>
                            <div className='form-group'>
                                <label htmlFor='clg'>College</label>
                                <select className='form-select' id="clg" {...register("College", { required: true })}>
                                    <option value="" defaultChecked>Select college...</option>
                                    <option value="KMIT">KMIT</option>
                                    <option value="NGIT">NGIT</option>
                                    <option value="KMEC">KMEC</option>
                                </select>
                                {errors.College && <span className='text-danger'>College is required</span>}
                            </div>
                            <div className='form-group'>
                                <label htmlFor='FSBatch'>FS Batch</label>
                                <select className='form-select' id="FSBatch" {...register("FSBatchId", { required: true })}>
                                    <option defaultChecked value="all">Select FS Batch...</option>
                                    {
                                        fsBatches.map(obj => <option value={obj.id} key={obj.id}>{obj.name}</option>)
                                    }
                                </select>
                                {errors.FSBatch && <span className='text-danger'>FS Batch is required</span>}
                            </div>
                            <div className='form-group'>
                                <label htmlFor='name'>Name</label>
                                <input type="text" className='form-control' placeholder='name' id="name" {...register("Name", { required: true })} />
                                {errors.Name && <span className='text-danger'>Name is required</span>}
                            </div>
                            <div className='form-group'>
                                <label htmlFor='uname'>Username</label>
                                <input type="text" className='form-control' placeholder='username' id="uname" {...register("Username", { required: true })} />
                                {errors.Username && <span className='text-danger'>Username is required</span>}
                            </div>
                            <div className='form-group'>
                                <label htmlFor='pass'>Password</label>
                                <input type="password" className='form-control' placeholder='password' id="pass" {...register("Password", { required: true })} />
                                {errors.Password && <span className='text-danger'>Password is required</span>}
                            </div>
                            <div className='form-group text-center'>
                                <button className='btn btn-success w-100'>Add</button>
                            </div>
                        </form>

                        {/* {
                    uploading === true ?
                        <div className="text-center">
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            <span className="sr-only"><strong>Uploading please wait...</strong></span>
                        </div>
                        :
                        <div>
                            {
                                (reports.length !== 0) &&
                                <div>
                                    <table className='table table-responsive table-bordered m-auto w-100 mb-2'>
                                        <tbody>
                                            <tr>
                                                <th>Total Records</th>
                                                <th>Inserted</th>
                                                <th>Duplicates</th>
                                                <th>Empty Fields</th>
                                            </tr>
                                            <tr>
                                                <td>{reports.Total}</td>
                                                <td>{reports.Inserted}</td>
                                                <td>{reports.Dup}</td>
                                                <td>{reports.EmptyFields}</td>
                                            </tr>
                                            <tr className='text-center'>
                                                <td colSpan="4"><button className='btn btn-link p-0' onClick={showdup}>{showDuplicates === true ? <>Hide Duplicates</> : <>Show Duplicates</>}</button></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            }
                        </div>
                } */}
                    </div>
            }
            {/* <div className='container-fluid'>
                {
                    showDuplicates === true && duplicates.length !== 0 &&
                    <table className='m-auto table table-responsive'>
                        <tbody>
                            <tr>
                                <th>Mentor Name</th>
                                <th>College Name</th>
                            </tr>
                            {
                                duplicates.map((obj) => <tr key={obj.MentorName}>
                                    <td>{obj.MentorName}</td>
                                    <td>{obj.CollegeName}</td>
                                </tr>
                                )
                            }
                        </tbody>
                    </table>
                }
            </div> */}
            <ToastContainer />
        </div>
    );
}

export default UploadFSTeachers;